import * as React from 'react';
import { FormEvent } from 'react';
import { AbstractFilterView, FilterViewProps, OptionsType } from './AbstractFilterView';
import { FilterOption } from './FilterOption';
import { OptionsCollection } from './OptionsCollection';
import { InputType, Item } from './Toggle/Item';

export interface ToggleFilterProps<T> extends FilterViewProps<T> {
}

export abstract class AbstractToggleFilter<VALUE_TYPE, P extends FilterViewProps<VALUE_TYPE>, OPTION_TYPE = VALUE_TYPE> extends AbstractFilterView<VALUE_TYPE, P> {
    constructor(props: Readonly<P>) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    protected abstract getType(): InputType;

    protected abstract handleInputChange(event: FormEvent<HTMLInputElement>): void ;

    protected abstract getOptions(): OptionsType<OPTION_TYPE>;

    protected renderInput(): JSX.Element | null {
        const className = 'pf-' + this.getType() + '-wrapper';

        return <div className={className}>
            {this.renderOptions(this.getOptions())}
        </div>;
    }

    private renderOptions(options: OptionsType<OPTION_TYPE>): JSX.Element[] {
        if (!(options instanceof OptionsCollection)) {
            return this.renderOptions(OptionsCollection.from(options));
        }

        const value = this.props.filter.value;
        const type = this.getType();

        return options.map(
            option => <Item key={option.name}
                            type={type}
                            option={option}
                            checked={this.isChecked(option, value)}
                            onChange={this.handleInputChange}/>
        );
    }

    private isChecked(option: FilterOption<OPTION_TYPE>, value: VALUE_TYPE) {
        if (typeof value === 'string') {
            return option.value === value;
        }
        if (typeof value === 'number') {
            return '' + value === option.value;
        }
        if (Array.isArray(value)) {
            return -1 < value.indexOf(option.value);
        }
    }
}
